import React from 'react';
import '../styles/CustomerHeader.css';

const CustomerHeader = ({ cart, onShowCart, onShowMarketplace }) => {
  const cartItemCount = cart ? cart.length : 0;
  const totalPrice = cart ? cart.reduce((total, item) => total + (parseFloat(item.price) * item.quantity), 0) : 0;

  return (
    <header className="customer-header">
      <div className="header-container">
        <div className="header-left">
          <h1 className="app-title">
            <span className="gradient-text">EZ</span>
            <span className="accent-text">Drink</span>
          </h1>
          <p className="app-subtitle">Skip the line, order instantly</p>
        </div>
        
        <div className="header-right">
          <button 
            className="marketplace-btn"
            onClick={onShowMarketplace}
          >
            🍽️ Browse Vendors
          </button>
          
          <button 
            className="cart-btn"
            onClick={onShowCart}
          >
            <span className="cart-icon">🛒</span>
            <span className="cart-text">Cart</span>
            {cartItemCount > 0 && (
              <span className="cart-badge">{cartItemCount}</span>
            )}
          </button>
          
          {cartItemCount > 0 && (
            <div className="cart-total">
              ${totalPrice.toFixed(2)}
            </div>
          )}
        </div>
      </div>
    </header>
  );
};

export default CustomerHeader;
